import { memo, useMemo } from "react"
import { CRS } from 'leaflet'
import { WMSTileLayer } from "react-leaflet"
import { useTranslation } from 'react-i18next'
import { useUserContext } from '../../../../hooks/UserSettingProvider'
import LayerOverlay from '../../../map/layers/overlays/LayerOverlay'
import { GeographyLayer, GROUPS } from '../../../../constants/string'


// provided by LongdoMap
const DolLayerOverlay = () => {
  const { t } = useTranslation()
  const { user } = useUserContext()
  const canViewDolMap = useMemo(() => user?.is_superuser || (user?.groups ?? []).includes(GROUPS.DOL), [user])

  if (!canViewDolMap) return <></>
  return (
    <LayerOverlay
      name='dol'
      title={<span style={{ color: GeographyLayer.Colors.DOL }}>{t(GeographyLayer.Labels.DOL)}</span>}
    >
      <WMSTileLayer
        url='https://ms.longdo.com/mapproxy/service'
        layers='dol'
        minZoom={1}
        minNativeZoom={1}
        maxNativeZoom={17}
        maxZoom={20}
        zIndex={350}
        version='1.3.0'
        crs={CRS.EPSG4326}
        format='image/png'
        transparent={true}
      />
    </LayerOverlay>
  )
}

export default memo(DolLayerOverlay)
